/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import uuid from 'uuid';
import { ApiHeadersService } from './api-headers';

@Injectable()
export class HttpInterceptorWrapper implements HttpInterceptor {
  constructor(private apiHeadersService: ApiHeadersService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    let serviceReferenceId: string | null = null;
    const requestId = uuid.v4();
    const storedId = sessionStorage.getItem('cigna-device-id');

    try {
      serviceReferenceId =
        new URL(req.url).searchParams.get('service_reference_id') ||
        req.body?.service_reference_id;
      if (serviceReferenceId) {
        sessionStorage.setItem('service_reference_id', serviceReferenceId);
      }
      // eslint-disable-next-line no-empty
    } catch (err) {}

    if (storedId) {
      // Add x-request-id header to all requests at the beginning

      req = req.clone({
        headers: req.headers
          .set(
            'x-request-id',
            serviceReferenceId ? serviceReferenceId : requestId,
          )
          .set(
            'x-cigna-trace-id',
            this.apiHeadersService.generateApiHeaders()['x-cigna-trace-id'],
          ),
      });
    }

    return next.handle(req);
  }
}
